import script from "./SitePlanComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SitePlanComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SitePlanComponent.vue?vue&type=style&index=0&id=37685c34&scoped=true&lang=scss"

import exportComponent from "F:\\Repos\\Freelance\\site-plan-viewerBW\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37685c34"]])

export default __exports__